import { Button, Card, Col, Flex, Form, Image, Input, Layout, Row, Typography } from 'antd'
import { useAttemptListener } from 'dev-masters-react-kit'
import { attemptLogin, AuthDTO } from '../../utils/redux/authSlice'
import { listenerMiddleware, useAppDispatch } from '../../utils/redux/store'
import './auth.scss'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import LogoImage from '../../assets/logo-image.png'
import WelcomeImage from './assets/welcome-image.jpg'

const { Title } = Typography

export default function SignIn() {
  const [signInForm] = Form.useForm<AuthDTO>()
  const dispatch = useAppDispatch()
  const { t } = useTranslation('common')

  function onFinish(values: AuthDTO) {
    dispatch(attemptLogin(values))
  }

  useAttemptListener({
    listenerMiddleware: listenerMiddleware,
    attempt: attemptLogin,
    onFulfilled: () => {
      console.log('authorized')
    },
  })

  return (
    <>
      <Layout className="auth">
        <Flex
          flex={1} 
          justify="center"
          align="center"
          style={{ margin: '3rem 0' }}
        >
          <Row
            style={{ 
              width: '80vw',
              borderRadius: '1rem',
              overflow: 'hidden',
            }}
          >
            <Col span={16}>
              <img
                src={WelcomeImage}
                alt="Welcome"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </Col>
            <Col 
              span={8}
              style={{
                padding: '2.5em',
                backgroundColor: '#1C1C1C',
                color: 'white',
              }}
            >
              <div 
                style={{ flexGrow: 1 }}
              >
                <img
                  src={LogoImage}
                  alt="MusicTMM"
                  style={{ height: '2.5rem', marginBottom: '3.5rem' }}
                />
                <Title level={5} 
                  style={{
                    textAlign: 'left',
                    marginBottom: 24,
                    color: 'white',
                    fontWeight: 'bold',
                  }}
                >
                  {t('Nice to see you again')}
                </Title>
                <Form
                  form={signInForm}
                  onFinish={onFinish}
                  className="login"
                  layout="vertical"
                  initialValues={{
                    email: process.env.REACT_APP_DEV_LOGIN,
                    password: process.env.REACT_APP_DEV_PASSWORD,
                  }}
                >
                  <Form.Item
                    name="email"
                    label={t('Login')}
                    rules={[
                      { required: true, message: 'Please input your email!' },
                      { type: 'email', message: 'Invalid email, example: user@gmail.com!' },
                    ]}
                  >
                    <Input placeholder={t('Email or phone number')} />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    label={t('password')}
                    rules={[{ required: true, message: 'Please input your password!' }]}
                  >
                    <Input.Password placeholder={t('Enter password')} />
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                      {t('Sign In')}
                    </Button>
                  </Form.Item>
                  <Flex justify="center">
                    <Typography.Text>Dont have an account?</Typography.Text>
                    &nbsp;
                    <Link to="/register">
                      {t('Sign up now')}
                    </Link>
                  </Flex>
                </Form>
              </div>
            </Col>
          </Row>

        </Flex>
      </Layout>
    </>
  )
}
